import { updateRatesCityRequest } from "../../data/ratesCityApi";
import { validateTarifaCityPayload } from "../validator/validateTarifaCityPayload";

export async function updateTarifaCityUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  const error = validateTarifaCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateRatesCityRequest(payload);
}
